var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3333 2.66669H10.6666C6.24835 2.66669 2.66663 6.24841 2.66663 10.6667V21.3334C2.66663 25.7516 6.24835 29.3334 10.6666 29.3334H21.3333C25.7516 29.3334 29.3333 25.7516 29.3333 21.3334V10.6667C29.3333 6.24841 25.7516 2.66669 21.3333 2.66669ZM5.33329 10.6667C5.33329 7.72117 7.72111 5.33335 10.6666 5.33335H21.3333C24.2788 5.33335 26.6666 7.72117 26.6666 10.6667V21.3334C26.6666 24.2789 24.2788 26.6667 21.3333 26.6667H10.6666C7.72111 26.6667 5.33329 24.2789 5.33329 21.3334V10.6667ZM16 22.6667C12.3181 22.6667 9.33329 19.6819 9.33329 16C9.33329 12.3181 12.3181 9.33335 16 9.33335C19.6819 9.33335 22.6666 12.3181 22.6666 16C22.6666 19.6819 19.6819 22.6667 16 22.6667ZM16 20C18.2091 20 20 18.2092 20 16C20 13.7909 18.2091 12 16 12C13.7908 12 12 13.7909 12 16C12 18.2092 13.7908 20 16 20ZM22.6666 10.6667C23.403 10.6667 24 10.0697 24 9.33335C24 8.59697 23.403 8.00002 22.6666 8.00002C21.9302 8.00002 21.3333 8.59697 21.3333 9.33335C21.3333 10.0697 21.9302 10.6667 22.6666 10.6667Z",
    fill: "#757575"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.5690b20305b6e4bff0dd636301ac5f3c.svg";
export { ForwardRef as ReactComponent };